import { render, staticRenderFns } from "./QuizCreatorImage.vue?vue&type=template&id=a1f0d428&"
import script from "./QuizCreatorImage.vue?vue&type=script&lang=js&"
export * from "./QuizCreatorImage.vue?vue&type=script&lang=js&"
import style0 from "./QuizCreatorImage.vue?vue&type=style&index=0&id=a1f0d428&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports